import { Box, EllipsisHIcon, Flex } from '@modusign/design-system';
import OutsideClickHandler from 'react-outside-click-handler';
import { useToggle } from 'react-use';

import HeaderButton from '@app/components/HeaderButton';

import './ExternalDocumentHeaderMoreToolsDropdown.scss';

interface ExternalDocumentHeaderMoreToolsDropdownProps {
  menus: { iconSrc: string; text: string; onClick: () => void }[];
}

// DocumentHeaderMoreToolsDropdown을 복사 후 수정함
function ExternalDocumentHeaderMoreToolsDropdown({
  menus,
}: ExternalDocumentHeaderMoreToolsDropdownProps) {
  const [dropdownToggle, toggleDropdown] = useToggle(false);

  if (menus.length === 0) {
    return null;
  }

  return (
    <OutsideClickHandler onOutsideClick={() => toggleDropdown(false)}>
      <Box display="inline-block" position="relative">
        <HeaderButton ariaLabel="더 보기" onClick={toggleDropdown}>
          <EllipsisHIcon height="22px" width="22px" />
        </HeaderButton>
        {dropdownToggle && (
          <Box
            alignItems="flex-end"
            className="ExternalDocumentHeader__tool-dropdown"
            display="flex"
            flexDirection="column"
            position="absolute"
            right="0"
            top="115%"
            width="154px"
          >
            <svg
              fill="none"
              height="12"
              style={{ display: 'block', marginRight: '14px' }}
              viewBox="0 0 16 12"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 0L0 12H16Z" fill="#212121" />
            </svg>
            <Box as="ul" bg="darkGray800" borderRadius="6px" paddingY={4}>
              {menus.map((menu) => (
                <Box
                  as="li"
                  key={menu.text}
                  sx={{
                    '&:hover': {
                      bg: 'darkGray700',
                    },
                  }}
                >
                  <Flex
                    alignItems="center"
                    as="button"
                    height="40px"
                    justifyContent="flex-start"
                    lineHeight="21px"
                    paddingX={4}
                    sx={{
                      position: 'relative',
                      '.ExternalDocumentHeaderMoreDropdown--tool-tip': {
                        display: 'none',
                        left: '50%',
                        px: 3,
                        py: 1,
                        position: 'absolute',
                        textAlign: 'left',
                        top: '16px',
                        width: '187px',
                      },
                      '&:disabled:hover': {
                        '& .ExternalDocumentHeaderMoreDropdown--tool-tip': {
                          display: 'block',
                        },
                      },
                    }}
                    type="button"
                    width="100%"
                    onClick={menu.onClick}
                  >
                    <img
                      alt=""
                      className="ExternalDocumentHeader__tool-dropdown-menu-icon"
                      src={menu.iconSrc}
                    />
                    <b>{menu.text}</b>
                  </Flex>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </OutsideClickHandler>
  );
}

export default ExternalDocumentHeaderMoreToolsDropdown;
